"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _blocks = require("@wordpress/blocks");

var _richText = require("@wordpress/rich-text");

var _migrate = require("./migrate");

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
function getListContentSchema(_ref) {
  let {
    phrasingContentSchema
  } = _ref;
  const listContentSchema = { ...phrasingContentSchema,
    ul: {},
    ol: {
      attributes: ['type', 'start', 'reversed']
    }
  }; // Recursion is needed.
  // Possible: ul > li > ul.
  // Impossible: ul > ul.

  ['ul', 'ol'].forEach(tag => {
    listContentSchema[tag].children = {
      li: {
        children: listContentSchema
      }
    };
  });
  return listContentSchema;
}

const transforms = {
  from: [{
    type: 'block',
    isMultiBlock: true,
    blocks: ['core/paragraph', 'core/heading'],
    transform: blockAttributes => {
      let childBlocks = [];

      if (blockAttributes.length > 1) {
        childBlocks = blockAttributes.map(_ref2 => {
          let {
            content
          } = _ref2;
          return (0, _blocks.createBlock)('core/list-item', {
            content
          });
        });
      } else if (blockAttributes.length === 1) {
        const value = (0, _richText.create)({
          html: blockAttributes[0].content
        });
        childBlocks = (0, _richText.split)(value, '\n').map(result => {
          return (0, _blocks.createBlock)('core/list-item', {
            content: (0, _richText.toHTMLString)({
              value: result
            })
          });
        });
      }

      return (0, _blocks.createBlock)('core/list', {
        anchor: blockAttributes.anchor
      }, childBlocks);
    }
  }, {
    type: 'block',
    blocks: ['core/quote', 'core/pullquote'],
    transform: _ref3 => {
      let {
        value,
        anchor
      } = _ref3;
      return (0, _blocks.createBlock)('core/list', {
        anchor
      }, (0, _richText.split)((0, _richText.create)({
        html: value,
        multilineTag: 'p'
      }), _richText.__UNSTABLE_LINE_SEPARATOR).map(result => {
        return (0, _blocks.createBlock)('core/list-item', {
          content: (0, _richText.toHTMLString)({
            value: result
          })
        });
      }));
    }
  }, ...['*', '-'].map(prefix => ({
    type: 'prefix',
    prefix,

    transform(content) {
      return (0, _blocks.createBlock)('core/list', {}, [(0, _blocks.createBlock)('core/list-item', {
        content
      })]);
    }

  })), ...['1.', '1)'].map(prefix => ({
    type: 'prefix',
    prefix,

    transform(content) {
      return (0, _blocks.createBlock)('core/list', {
        ordered: true
      }, [(0, _blocks.createBlock)('core/list-item', {
        content
      })]);
    }

  })), {
    type: 'raw',
    selector: 'ol,ul',
    schema: args => ({
      ol: getListContentSchema(args).ol,
      ul: getListContentSchema(args).ul
    }),
    transform: _migrate.createListBlockFromDOMElement
  }],
  to: [...['core/paragraph', 'core/heading'].map(block => ({
    type: 'block',
    blocks: [block],
    transform: (_attributes, childBlocks) => {
      return childBlocks.filter(_ref4 => {
        let {
          name
        } = _ref4;
        return name === 'core/list-item';
      }).map(_ref5 => {
        let {
          attributes
        } = _ref5;
        return (0, _blocks.createBlock)(block, {
          content: attributes.content
        });
      });
    }
  })), ...['core/quote', 'core/pullquote'].map(block => ({
    type: 'block',
    blocks: [block],
    transform: (attributes, innerBlocks) => {
      return (0, _blocks.switchToBlockType)((0, _blocks.switchToBlockType)((0, _blocks.createBlock)('core/list', attributes, innerBlocks), 'core/paragraph'), block);
    }
  }))]
};
var _default = transforms;
exports.default = _default;
//# sourceMappingURL=transforms.js.map